import util from './util.js'
import { pre_url } from './config'
//v1.0.0

async function login(userName,password){
	let url = pre_url + "adminLogin";
  return await util.request(url,{userName,password});
}

async function product_drop_images(files){
  let url = pre_url + "dropImages";
  return await util.request(url,{files});
}

async function set_product(productId,productInfo){
  let url = pre_url + "setProduct";
  return await util.request(url,{productId,productInfo});
}

async function del_product(productId,password){
  let url = pre_url + "deleteProduct";
  return await util.request(url,{productId,password});
}

async function get_batches(page,pageSize,options = {}){
  let url = pre_url + "getBatches";
  return await util.request(url,{page,pageSize,options});
}

async function set_batches(name, count, validDays = 0){
  let url = pre_url + "setBatches";
  return await util.request(url,{name, count, validDays});
}

async function get_codes(batchId,page,pageSize,status){
  let url = pre_url + "getCodesById";
  return await util.request(url,{batchId,page,pageSize,status});
}

async function get_user_upload(groupId,a){
  let url = pre_url + "getUserUploadById";
  return await util.request(url,{groupId,a});
}

async function set_carousel(carouselId,info){
  let url = pre_url + "setCarousel";
  return await util.request(url,{carouselId,info});
}

async function delete_carousel(carouselId){
  let url = pre_url + "deleteCarousel";
  return await util.request(url,{carouselId});
}

async function set_coupon(couponId,opt){
  let url = pre_url + "setCoupon";
  return await util.request(url,{couponId,opt});
}

async function update_sort_index(sortArray){
  let url = pre_url + "updateSortIndex";
  return await util.request(url,{sortArray});
}

async function create_group(info){
  let url = pre_url + "setUploadFile";
  return await util.request(url,{info});
}

async function get_admin_upload(page,limit,type){
  let url = pre_url + "getUserUpload";
  return await util.request(url,{page,limit,type});
}

async function set_waybill(orderId,waybillNo){
  let url = pre_url + "setWaybillNo";
  return await util.request(url,{orderId,waybillNo});
}

async function set_categories(categoryId,opt){
  let url = pre_url + "setCategories";
  return await util.request(url,{categoryId,opt});
}

async function delete_category(categoryId){
  let url = pre_url + "deleteMessage";
  return await util.request(url,{type: 'categories', ids: categoryId});
}

async function get_message(type , options){
  let url = pre_url + "getMessage";
  return await util.request(url,{type , options});
}

async function set_message(type , info){
  let url = pre_url + "setMessage";
  return await util.request(url,{type , info});
}

async function delete_message(type,ids){
  let url = pre_url + "deleteMessage";
  return await util.request(url,{type , ids});
}

async function drop_files(files){
  let url = pre_url + "dropFiles";
  return await util.request(url,{files});
}

async function file_upload(fileType,formData){
  let url =  `${pre_url}fileUpload?type=${fileType}`;
  return await util.request(url,formData,true);
}

export default {
  login,
  product_drop_images,
  set_product,
  get_batches,
  set_batches,
  get_codes,
  get_user_upload,
  set_carousel,
  delete_carousel,
  set_coupon,
  update_sort_index,
  create_group,
  get_admin_upload,
  drop_files,
  set_waybill,
  set_categories,
  delete_category,
  del_product,
  get_message,
  set_message,
  file_upload,
  delete_message
}



//////////////////
// WEBPACK FOOTER
// ./static/request_server.js
// module id = null
// module chunks = 